import { render, staticRenderFns } from "./ChatPushPermissionPrompt.vue?vue&type=template&id=46a570fa&scoped=true"
import script from "./ChatPushPermissionPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPushPermissionPrompt.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatPushPermissionPrompt.vue?vue&type=style&index=0&id=46a570fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a570fa",
  null
  
)

export default component.exports